import type { PlanType } from '@/services/billing/plans';

/**
 * The human-readable label for the account's current plan: premium/essentials trials take
 * precedence, then an active subscription renders as `<plan type> subscription`, otherwise empty.
 */
export function getCurrentPlan(
  isPremiumTrial: boolean,
  isTrial: boolean,
  isSubscriptionActive: boolean,
  planType?: PlanType,
): string {
  let currentPlanInfo = '';
  if (isPremiumTrial === true) {
    currentPlanInfo = 'Premium trial';
  } else if (isTrial === true) {
    currentPlanInfo = 'Essentials trial';
  } else if (isSubscriptionActive === true) {
    currentPlanInfo = `${planType ?? 'Unknown'} subscription`;
  }
  return currentPlanInfo;
}
